/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Rush Hour Real Estate Platform API
 * MVP платформы недвижимости - публичные эндпоинты
 * OpenAPI spec version: 1.0.0
 */

export type ListLotsSort = (typeof ListLotsSort)[keyof typeof ListLotsSort]

export const ListLotsSort = {
  price_asc: 'price_asc',
  price_desc: 'price_desc',
  area_desc: 'area_desc',
  newest: 'newest',
} as const
